import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

// eslint-disable-next-line import/prefer-default-export
export const useDatasetMappedValue = (
	mapValue: number | undefined,
	mapperId: number
) => {
  const { data } = useGetDatasetMapperData(mapperId)
	if (!mapValue || !data) return null;
	return data?.mappings[mapValue];
};